import { action } from 'typesafe-actions';
import { UserTypes, User } from './types';

export const doLogin = (data: User) => action(UserTypes.DO_LOGIN, {data});
export const doLogout = () => action(UserTypes.DO_LOGOUT);